__turbopack_context__.v({
  "gallerySmallTop": "imageGallery-module-scss-module__6WDl4a__gallerySmallTop",
  "img": "imageGallery-module-scss-module__6WDl4a__img",
  "imgContainer": "imageGallery-module-scss-module__6WDl4a__imgContainer",
  "row": "imageGallery-module-scss-module__6WDl4a__row",
});
